var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyInfoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_02 - super admin",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1000,
    transform: "translate(-1000 -39)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 219",
    x: -735,
    y: -39,
    width: 1175,
    height: 1000,
    fill: "#F0F6F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.01912 8.61299V5.32901M13.0311 3.57776V7.87425C13.0313 8.21285 12.9647 8.54816 12.8352 8.86102C12.7057 9.17389 12.5159 9.45817 12.2765 9.69762C12.0371 9.93707 11.7529 10.127 11.44 10.2566C11.1272 10.3861 10.7919 10.4528 10.4533 10.4527H8.73459L7.31695 11.8703C7.27829 11.9113 7.23168 11.9439 7.17996 11.9662C7.12824 11.9885 7.07251 12 7.01619 12C6.95987 12 6.90414 11.9885 6.85243 11.9662C6.80071 11.9439 6.75409 11.9113 6.71543 11.8703L5.29779 10.4527H3.57776C3.23919 10.4527 2.90394 10.386 2.59115 10.2564C2.27836 10.1268 1.99416 9.93687 1.75478 9.69743C1.5154 9.45799 1.32554 9.17375 1.19603 8.86092C1.06653 8.5481 0.999915 8.21283 1 7.87425V3.57776C1 2.8941 1.27159 2.23843 1.75501 1.75501C2.23843 1.27159 2.8941 1 3.57776 1H10.4527C11.1363 1 11.792 1.27159 12.2754 1.75501C12.7588 2.23843 13.0311 2.8941 13.0311 3.57776Z",
    stroke: "#0A7F8F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.94922 3.24609H6.95312",
    stroke: "#0A7F8F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1000,
    fill: "white",
    transform: "translate(-1000 -39)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfoImg);
export default __webpack_public_path__ + "static/media/CompanyInfoImg.2ee2e1006c4f2cdf858c2486b9163795.svg";
export { ForwardRef as ReactComponent };